var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { currencyTokenAssets } from '../../utils/currency-token-assets';
export default function ClaimToken(_a) {
    var ctaTokenValue = _a.ctaTokenValue, wallet = _a.wallet;
    var t = useI18n().t;
    return (_jsx(Container, { children: _jsx("p", { className: "confirm", children: _jsx(Trans, { components: {
                    gold: _jsx("span", { className: "gold number" }),
                    purple: _jsx("span", { className: "purple" }),
                    ctaTokenIcon: _jsx("img", { alt: "", src: currencyTokenAssets[CurrencyTokenSymbol.CTA] }),
                }, i18nKey: "claim-token.confirm.description", t: t, values: {
                    ctaTokenValue: ctaTokenValue,
                    wallet: wallet,
                } }) }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n\n  .confirm {\n    display: inline-block;\n    text-align: center;\n\n    & > img {\n      height: 32px;\n      margin-bottom: -10px;\n      width: auto;\n    }\n\n    .gold {\n      color: ", ";\n      font-size: 20px;\n      margin-right: 4px;\n    }\n\n    .purple {\n      color: ", ";\n      font-weight: 700;\n      margin-left: 4px;\n    }\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n\n  .confirm {\n    display: inline-block;\n    text-align: center;\n\n    & > img {\n      height: 32px;\n      margin-bottom: -10px;\n      width: auto;\n    }\n\n    .gold {\n      color: ", ";\n      font-size: 20px;\n      margin-right: 4px;\n    }\n\n    .purple {\n      color: ", ";\n      font-weight: 700;\n      margin-left: 4px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.gold;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.purple;
});
var templateObject_1;
